var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVennDiagramIntersection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454.815 454.815",
    style: {
      enableBackground: "new 0 0 454.815 454.815"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320.021,92.61c-35.843,0-68.447,14.091-92.613,36.98c-24.169-22.896-56.767-36.98-92.609-36.98 C60.47,92.61,0,153.08,0,227.411c0,74.322,60.47,134.795,134.798,134.795c35.843,0,68.44-14.091,92.609-36.983 c24.166,22.898,56.771,36.983,92.613,36.983c74.322,0,134.795-60.473,134.795-134.795C454.815,153.08,394.343,92.61,320.021,92.61z M134.798,350.1c-67.658,0-122.693-55.047-122.693-122.689c0-67.651,55.041-122.695,122.693-122.695 c32.58,0,62.16,12.85,84.143,33.641c-20.965,23.768-33.727,54.947-33.727,89.055c0,34.117,12.761,65.29,33.727,89.063 C196.958,337.25,167.378,350.1,134.798,350.1z M197.319,227.411c0-30.683,11.405-58.708,30.088-80.241 c18.682,21.533,30.089,49.559,30.089,80.241c0,30.677-11.407,58.706-30.089,80.232 C208.724,286.117,197.319,258.087,197.319,227.411z M320.021,350.1c-32.58,0-62.164-12.85-84.146-33.638 c20.965-23.773,33.727-54.946,33.727-89.063c0-34.111-12.762-65.287-33.727-89.055c21.987-20.791,51.565-33.641,84.146-33.641 c67.654,0,122.689,55.042,122.689,122.696C442.71,295.042,387.675,350.1,320.021,350.1z M235.438,170.665h-17.901v-6.053h17.901 V170.665z M219.177,284.154h17.904v6.053h-17.904V284.154z M247.803,192.103h-39.345v-6.053h39.345V192.103z M251.586,211.52 h-50.053v-6.052h50.053V211.52z M253.347,225.392v6.05h-51.881v-6.05H253.347z M204.051,245.167h46.695v6.053h-46.695V245.167z M208.458,264.483h35.562v6.053h-35.562V264.483z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVennDiagramIntersection);
export default __webpack_public_path__ + "static/media/venn_diagram_intersection.e33ff393451b0290f345b346997b3d2d.svg";
export { ForwardRef as ReactComponent };